import {context, ROOT_CONTEXT, Span, trace} from '@opentelemetry/api';
import {environment} from '@environments/environment';

let _currentNavigationSpan: Span | null = null;

export function getCurrentNavigationSpan(): Span | null {
  return _currentNavigationSpan;
}

export function setCurrentNavigationSpan(span: Span | null): void {
  _currentNavigationSpan = span;
}

/**
 * Runs `fn` under a fresh root span so any HTTP it triggers is attributed to that span rather than
 * being adopted by the current navigation span. `NavigationAwareContextManager` injects the
 * navigation span into any context that has no active span, so periodic/background work (auto-
 * refresh timers, polling) that fires during an in-flight navigation would otherwise be parented
 * to — and pollute — the "Page" span. Establishing an explicit span here makes that guard skip.
 *
 * When OTel is disabled the tracer and context manager are no-ops, so this just invokes `fn`.
 */
export function runInBackgroundTrace<T>(name: string, fn: () => T): T {
  const span = trace.getTracer(environment.datadog.service).startSpan(name, {}, ROOT_CONTEXT);
  try {
    return context.with(trace.setSpan(ROOT_CONTEXT, span), fn);
  } finally {
    span.end();
  }
}
